import store from "@/store";
import request from "@/utils/request";

export async function getCsCodeList(params) {
    console.log("@@ get list : getCsCodeList");
    let result = request.get("/api/cs/csCode/",{params});
    return result;
}

export async function getCsCodeItem(params) {
    console.log("@@ get item : getCsCodeItem");
    let result = request.get(`/api/cs/csCode/${params.code}`,{params} );
    return result;
}

export async function saveCsCode(params) {
    console.log("@@ post save : saveCsCode");
    let result = request.post(`/api/cs/csCode/`,params);
    return result;
}

export async function deleteCsCode(params) {
    console.log("@@ delete : deleteCsCode");
    let result = request.delete(`/api/cs/csCode/${params.code}`,{params});
    return result;
}
